export const wrapper =
  'w-full h-full flex flex-col justify-center items-center';
export const card = 'box-shadow';
